import React, { useState } from "react";
import { Input, InputContainer } from "./FloatLabelInputPassword.style";
import { RedEye, WhiteEye } from "../../assets/profile";

const FloatLabelInputPassword = (props) => {
  const [focus, setFocus] = useState(false);
  let { label, value, placeholder, type, required } = props;

  if (!placeholder) placeholder = label;

  const isOccupied = focus || (value && value.length !== 0);
  // const isOccupied = focus;

  const labelClass = isOccupied ? "label as-label" : "label as-placeholder";

  const requiredMark = required ? <span className="text-danger">*</span> : null;

  const renderEyeIcon = (visible) => (
    visible ? <RedEye /> : <WhiteEye />
  )

  const handleKeyDown = (event) => {
    const key = event.key;
    const isAllowedKey = /^[0-9\b]+$/.test(key);
    if (!isAllowedKey && key !== "Backspace") {
      event.preventDefault();
    }
  };


  return (
    <InputContainer
      className="float-label"
      onBlur={() => setFocus(false)}
      onFocus={() => setFocus(true)}
    >
      <Input 
        onChange={props.onChange} 
        type={type} 
        defaultValue={value} 
        iconRender={renderEyeIcon}
        onKeyDown={handleKeyDown}
      />
      <label className={labelClass}>
        {isOccupied ? label : placeholder} {requiredMark}
      </label>
    </InputContainer>
  );
};

export default FloatLabelInputPassword;
